import React from 'react';
import { FormControlLabel, Checkbox } from '@mui/material';
import { useTranslation } from 'services/localization/useTranslation';

interface PreparationCheckboxProps {
	checked: boolean;
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const PreparationCheckbox = ({ checked, onChange }: PreparationCheckboxProps) => {
	const { t } = useTranslation();
	return (
		<FormControlLabel
			control={<Checkbox color="primary" checked={checked} onChange={onChange} />}
			label={t('rentals.orderPrepared2', 'Order prepared')}
		/>
	);
};

export default PreparationCheckbox;
